<template>
    <div class="content-lesson-planing">
        <div class="row">
            <div class="col-md-4 wrap-left">
                <div v-for="(item, index) of listLessonPlaning" :key="index" class="item-electronic-lecture">
                    <div class="name">
                        <h5 @click="handleOnCollapse(item)"><strong>{{ item.name }} <img
                                    v-if="item.listChapterClassSchool.length > 0" class="icon-down-arrow width-20"
                                    src="@/assets/img/down-arrow.png" /></strong>
                        </h5>

                    </div>
                    <b-collapse class="wrap-list-chapter indented" :visible="item.isCollapse">
                        <div v-for="(chapter, indexChapter) of item.listChapterClassSchool" :key="indexChapter"
                            class="item-chapter">
                            <h6 @click="handleOnCollapse(chapter)"><strong>{{ chapter.name }} <img
                                        v-if="chapter.listPostClassSchool.length > 0" class="icon-down-arrow width-20"
                                        src="@/assets/img/down-arrow.png" /></strong>

                            </h6>


                            <b-collapse v-for="(poster, indexPoster) of chapter.listPostClassSchool" :key="indexPoster"
                                class="wrap-list-post indented" :visible="true">
                                <div class="item-post">
                                    <div>{{ poster.name }}</div>
                                    <div v-for="(document, indexDocument) of poster.listDocumentClassSchool"
                                        :key="indexDocument" class="wrap-list-document">
                                        <div class="item-document">
                                            <b-form-radio @change="handleOnViewDocument(document)" name="radio">
                                                {{ document.name }}
                                            </b-form-radio>
                                        </div>

                                    </div>
                                </div>

                            </b-collapse>
                        </div>


                    </b-collapse>
                </div>
                <div class="wrap-file">
                    <div class="title">
                        <h6 @click="handleToggleCollapseFile"><strong>Tài liệu đính kèm</strong>
                            <img v-if="listDataFile.length > 0" class="icon-down-arrow width-20"
                                src="@/assets/img/down-arrow.png" />
                        </h6>
                    </div>
                    <b-collapse class="mt-1" :visible="isCollapseFile">
                        <div class="wrap-list-file indented">
                            <div v-for="(item, index) of listDataFile" :key="index" class="item-file">
                                <div class="file-name" @click="handleOnViewFile(item)"><img class="icon-photo" src="@/assets/img/photo.png" /> {{
                                    item.fileName }}
                                </div>

                            </div>

                        </div>
                    </b-collapse>

                </div>
                <!-- <div class="wrap-task-lesson">
                    <div class="title">
                        <h6 @click="handleToggleCollapseFile"><strong>Nhiệm vụ học tập</strong>
                            <img v-if="listDataFile.length > 0" class="icon-down-arrow width-20"
                                src="@/assets/img/down-arrow.png" />
                        </h6>
                    </div>
                    <b-collapse class="mt-1" :visible="isCollapseFile">
                        <div class="wrap-list-file indented">
                            <div v-for="(item, index) of listDataFile" :key="index" class="item-file">
                                <div class="file-name"><img class="icon-photo" src="@/assets/img/photo.png" /> {{
                                    item.fileName }}
                                </div>

                            </div>

                        </div>
                    </b-collapse>
                </div> -->
            </div>
            <div class="col-md-8">
                <div class="view-document">
                    <ViewDocument v-if="isShowViewDocument" :item="itemSelect" />
                    <ViewFile :path="pathSelected" v-if="isShowFile" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">

            </div>
            <div class="col-md-8">
                <CommentContentLessonPlaningDelivered />
            </div>
        </div>
    </div>
</template>
<script>

import { GetListLessonPlaning } from './../../../_api/LessonClassSchoolServices'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../../constants/constants_enum'
import ViewDocument from './../../../_components/ViewDocument'
import CommentContentLessonPlaningDelivered from './CommentContentLessonPlaningDelivered'
import { listFileElectronicByLessonPlaning } from './../../../_api/fileClassSchoolServices'
import ViewFile from './../../../_components/ViewFile'
export default {
    components: {
        ViewDocument,
        ViewFile,
        CommentContentLessonPlaningDelivered
    },
    data() {
        return {
            isCollapseFile: false,
            listLessonPlaning: [],
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            paramQueryData: {
                id: 0,
                type: ELECTRONIC_LECTURE_WAREHOUSE,
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
            },
            isShowViewDocument: false,
            itemSelect: {},
            paramQueryDataFile: {
                lessonClassSchoolId: 0,
                keyword: '',
                pageIndex: 1,
                pageSize: 99999,
                type: PLANING_LESSON_WAREHOUSE
            },
            listDataFile: [],
            totalRecordsFile: 0,
            pathSelected:'',
            isShowFile:false
        }
    },
    mounted() {
        this.paramQueryData.id = this.paramQueryDataFile.lessonClassSchoolId = this.$route.query.id
        this.getListLessonPlaning()
        this.getDataFile()
    },
    methods: {
        handleToggleCollapseFile() {
            this.isCollapseFile = !this.isCollapseFile
        },
        handleOnCollapse(item) {
            item.isCollapse = !item.isCollapse
        },
        handleOnViewDocument(document) {
            console.log(document)
            this.isShowViewDocument = true
            this.isShowFile = false
            this.itemSelect = document
        },
        handleOnViewFile(file) {
            this.isShowViewDocument = false
            this.isShowFile = true
            this.pathSelected = file.path
            this.nameSelected = file.fileName
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        getDataFile() {
            let self = this
            listFileElectronicByLessonPlaning(this.paramQueryDataFile).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFile = res.data
                    //self.totalRecordsFile = res.data.paging.totalRecords
                }
            })
        },
        getListLessonPlaning() {
            let self = this
            GetListLessonPlaning(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLessonPlaning = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.item-document{
    color: blue;
}
.wrap-list-file .file-name {
    cursor: pointer;
}

.view-document {
    height: 30rem;
    background: rgb(241, 240, 240);
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid gray;
    padding: 5px;
}

.wrap-left {
    max-height: 30rem;
    overflow: auto;
    .item-electronic-lecture {
        .name {
            padding-bottom: 0px;
            border-bottom: 1px solid #d3dbe0;
        }

        .wrap-list-chapter {
            margin-top: 3px;

            .item-chapter {
                padding-bottom: 0px;
                border-bottom: 1px solid #d3dbe0;
            }

            .wrap-list-post {
                margin-top: 3px;

                .item-post {
                    // padding-bottom: 0px;
                    // border-bottom: 1px solid #d3dbe0;
                }
            }
        }
    }
}

.icon-photo {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.width-20 {
    width: 20px;
    cursor: pointer;
}
</style>